import DBEntity from './DBEntity';
import TableProperty from './TableProperty';

export default class Table extends DBEntity {
  #primaryKey;
  #constraints;
  #properties;

  constructor(name = '') {
    super(name);
    this.#primaryKey = [];
    this.#constraints = [];
    this.#properties = [];
  }

  addPrimaryKey(key) {
    this.#primaryKey.push(key);
  }

  addPrimaryKeyArray(primaryKeys) {
    primaryKeys.forEach(key => {
      this.#primaryKey.push(key);
    });
  }

  getPrimaryKeys() {
    return this.#primaryKey;
  }

  addNewConstraint(constraint) {
    this.#constraints.push(constraint);
  }

  getConstraint() {
    return this.#constraints;
  }

  addProperty(property) {
    this.#properties.push(property);
  }

  getProperties() {
    return this.#properties;
  }

  getSpecificProp(propName) {
    for (let index = 0; index < this.#properties.length; index++) {
      const prop = this.#properties[index];
      if (prop.getName() === propName) {
        return prop;
      }
    }
  }

  getCreationString() {
    let propertiesStr = '(\n';
    this.getProperties().forEach((prop, index) => {
      if (index !== this.getProperties().length - 1) {
        propertiesStr += `${prop.getName()} ${prop.getType()},\n`;
      } else {
        propertiesStr += `${prop.getName()} ${prop.getType()}`;
      }
    });

    let prStr = ``;
    if (this.#primaryKey.length === 1) {
      prStr += `${this.#primaryKey[0]}`;
    } else if (this.#primaryKey.length > 1) {
      prStr += '(';
      this.#primaryKey.forEach((pr, index) => {
        if (index !== this.#primaryKey.length - 1) {
          prStr += `${pr},`;
        } else {
          prStr += `${pr}`;
        }
      });
      prStr += ')';
    }

    let constraint = '';
    if (this.#constraints.length === 1) {
      if (
        this.getProperties().find(
          prop => prop.getName() === this.#constraints[0]
        )
      ) {
        constraint += `${this.getPrimaryKeys().length > 0 ? ', ' : ''}${
          this.#constraints[0]
        }`;
      }
    } else if (this.#constraints.length > 1) {
      this.#constraints.forEach((con, index) => {
        if (index === 0) {
          if (this.getProperties().find(prop => prop.getName() === con)) {
            constraint += `${
              this.getPrimaryKeys().length > 0 ? ', ' : ''
            }${con}`;
          }
        } else {
          if (this.getProperties().find(prop => prop.getName() === con)) {
            constraint += `, ${con}`;
          }
        }
      });
    }

    const tableStr = `CREATE TABLE ${this.getName()}${propertiesStr}${
      prStr !== '' || constraint !== ''
        ? `,\n PRIMARY KEY (${prStr}${constraint})\n`
        : '\n'
    });\n`;
    return tableStr;
  }

  getCopy() {
    const newTable = new Table(this.getName());

    this.getProperties().forEach(prop => {
      newTable.addProperty(
        new TableProperty(prop.getName(), prop.getType(), prop.isNested())
      );
    });

    return newTable;
  }

  addKeysArray(keys) {
    if (keys.length > 0) {
      console.log(keys);
      if (this.getPrimaryKeys().length === 0) {
        const firstKey = keys[0];
        this.addPrimaryKey(firstKey);
        keys.shift();
      }
      if (this.getConstraint().length === 0) {
        this.#constraints = [...keys];
      } else {
        this.#constraints = [...keys, ...this.#constraints];
      }
    }
    console.log(keys);

    this.getPrimaryKeys().forEach(key => {
      const itemIndex = this.getConstraint().indexOf(key);
      if (itemIndex > -1) {
        this.#constraints.splice(itemIndex, 1);
      }
    });
    console.log(keys);
  }
}
